// 角色管理
import Request from '../base'
export default {
  saveRole (options) {
    return Request.post('/eberuser/userapi/user/role/save', options)
  },
  deleteRole (options) {
    return Request.post('/eberuser/userapi/user/role/delete', options)
  },
  loadRole (options) {
    return Request.post('/eberuser/userapi/user/role/load', options)
  },
  listRole (options) {
    return Request.post('/eberuser/userapi/user/role/list', options)
  },
  saveOrgRole (options) {
    return Request.post('/eberuser/userapi/user/orgRole/save', options)
  },
  deleteOrgRole (options) {
    return Request.post('/eberuser/userapi/user/orgRole/delete', options)
  },
  loadOrgRole (options) {
    return Request.post('/eberuser/userapi/user/orgRole/load', options)
  },
  listOrgRole (options) {
    return Request.post('/eberuser/userapi/user/orgRole/list', options)
  }
}
